import { render, staticRenderFns } from "./TwoList.vue?vue&type=template&id=e713ce68"
import script from "./TwoList.vue?vue&type=script&lang=js"
export * from "./TwoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports